import * as React from "react";
const SvgGoogleGemini = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 512 512", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("radialGradient", { id: "a", cx: -37.129, cy: 650.866, r: 32, gradientTransform: "matrix(16.1326 5.4553 43.7005 -129.2322 -27793.309 84523.438)", gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { offset: 0.067, style: {
  stopColor: "#9168c0"
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.343, style: {
  stopColor: "#5684d1"
} }), /* @__PURE__ */ React.createElement("stop", { offset: 0.672, style: {
  stopColor: "#1ba1e3"
} })), /* @__PURE__ */ React.createElement("path", { d: "M512 256.5c-137.5 8.4-247.1 118-255.5 255.5h-1C247.1 374.5 137.5 264.9 0 256.5v-1c137.5-8.4 247.1-118 255.5-255.5h1c8.4 137.5 118 247.1 255.5 255.5z", style: {
  fill: "url(#a)"
} }));
export default SvgGoogleGemini;
